var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCancelFilled = function SvgCancelFilled(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.86255C6.47 2.86255 2 7.33255 2 12.8625C2 18.3925 6.47 22.8625 12 22.8625C17.53 22.8625 22 18.3925 22 12.8625C22 7.33255 17.53 2.86255 12 2.86255ZM17 16.4525L15.59 17.8625L12 14.2725L8.41 17.8625L7 16.4525L10.59 12.8625L7 9.27255L8.41 7.86255L12 11.4525L15.59 7.86255L17 9.27255L13.41 12.8625L17 16.4525Z",
    fill: "#DB1E1E"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCancelFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "cancel-filled.c1cbe50921d5e981dde10d4cc8a9cf6c.svg";